const ParticipantIds = {
    visitor: 0,
    system: -1,
    bot: -2,
    prechat: -3,
    predefined: -4,
    nonVisitorSystem: -6, // system message to be shown on only dashboard end, and not on visitor end
    pokeMessage: -7,
    AIBot: -8
};
export default ParticipantIds;
